import { FiLayers } from "react-icons/fi";

export default function OverlayHeading({ title, description, icon = <FiLayers /> }) {
	return <div className="akello-overlay-heading">
		{icon && <span className="akello-overlay-heading-icon" aria-hidden="true">{icon}</span>}
		<div className="akello-overlay-heading-copy">
			<span className="akello-overlay-heading-title">{title}</span>
			{description && <span className="akello-overlay-heading-description">{description}</span>}
		</div>
	</div>;
}
